import * as React from 'react';

import { spinnerService } from './SpinnerService';
import LinearProgress from '@material-ui/core/LinearProgress';

export class SpinnerComponent extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      show: this.props.hasOwnProperty('show') ? this.props.show : false,
      progress: this.props.hasOwnProperty('progress') ? this.props.progress : 0,
    };

    if (this.props.hasOwnProperty('spinnerService')) {
      this.spinnerService = this.props.spinnerService;
    } else {
      this.spinnerService = spinnerService;
    }

    this.spinnerService._register(this);
  }

  componentWillUnmount() {
    this.spinnerService._unregister(this);
  }

  get name() {
    return this.props.name;
  }

  get group() {
    return this.props.group;
  }

  get show() {
    return this.state.show;
  }

  set show(show) {
    this.setState({ show });
  }

  set progress(progress) {
    this.setState({ progress });
  }

  render() {
    let divStyleShow = { display: 'block', opacity: 1 };
    let divStyleHide = { display: 'block', opacity: 0 };

    if (this.state.show) {
      return (
        <div style={divStyleShow}>
          <LinearProgress
            variant={ this.props.name }
            value={ this.state.progress }
            classes={{
              colorPrimary: 'dark-blue',
              colorSecondary: 'primary-color',
              bar1Determinate: 'input-bg',
              bar1Indeterminate: 'input-bg',
              bar2Indeterminate: 'main-bg',
            }}
          />
        </div>
      );
    }
    return (<div style={divStyleHide}></div>);
  }
}
